<template>
  <v-dialog
    v-model="createPhotoModal"
    :fullscreen="showFullScreen"
    transition="dialog-bottom-transition"
    content-class="no-radius"
    persistent
    max-width="760px"
  >
    <v-card>
      <v-card-title
        class="pr-2"
        :style="{ backgroundColor: companyPrimaryColor }"
      >
        <h2 style="color:white">Foto's maken</h2>
        <v-spacer></v-spacer>
        <v-btn v-if="!busy" icon dark @click="closedialog()">
          <v-icon dark color="white">close</v-icon>
        </v-btn>
        <div v-else class="modal-loader"></div>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-container text-xs-center class="pa-0 ma-0">
          <!-- <v-flex xs12 class="turnportrait">
            <v-row justify="space-around" class="pa-4">
              <v-icon :color="companyPrimaryColor" size="100px">
                screen_rotation
              </v-icon>
            </v-row>
            <p class="ma-0" style="width: 100%; text-align: center;">
              Draai de tablet portrait om een foto te maken.
            </p>
          </v-flex> -->

          <div
            v-if="!busy"
            class="input-content-wrapper padding-top upload-image-wrapper"
          >
            <div class="choose-measurement-type-wrapper">
              <div class="choose-measurement-type-buttons clear">
                <div
                  class="measurement-type-button one"
                  v-bind:class="[{ active: before }, checkActiveComp()]"
                  @click="
                    photoBA = 0;
                    after = false;
                    before = true;
                    checkup = false;
                  "
                >
                  BEFORE
                </div>
                <div
                  class="measurement-type-button two"
                  v-bind:class="[{ active: after }, checkActiveComp()]"
                  @click="
                    photoBA = 1;
                    after = true;
                    before = false;
                    checkup = false;
                  "
                >
                  AFTER
                </div>
                <div
                  v-if="activeCompData.id == 'beautybyroos'"
                  class="measurement-type-button three"
                  v-bind:class="[{ active: checkup }, checkActiveComp()]"
                  @click="
                    photoBA = 2;
                    after = false;
                    before = false;
                    checkup = true;
                  "
                >
                  CONTROLE
                </div>
              </div>
            </div>
          </div>

          <v-layout row wrap>
            <v-flex xs12 sm3 class="upload-image-wrapper">
              <p class="ma-0" style="text-align: center">Voorkant</p>

              <div class="img-container" style="position: relative;">
                <img
                  style="position: absolute"
                  id="front"
                  v-if="selectedFileBase64.front"
                  :src="imageUrl.front"
                  aspect-ratio="1"
                  class="grey lighten-4 img-to-fit"
                />
                <v-row
                  style="position: absolute"
                  v-if="imageResizeLoader.front"
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-1"
                  ></v-progress-circular>
                </v-row>
              </div>

              <v-btn
                class="mt-2"
                block
                :dark="imageAddAvailable"
                :depressed="!imageAddAvailable"
                :disabled="!imageAddAvailable"
                :color="companySecondaryColor"
                @click="onPickFile('front')"
              >
                Maak foto
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="image/*"
                @change="onFilePicked"
              />

              <v-checkbox
                :color="companyPrimaryColor"
                class="my-2"
                v-if="!busy"
                label="Toestemming voor delen"
                v-model="Socialmedia.front"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm3 class="upload-image-wrapper">
              <p class="ma-0" style="text-align: center">Zijkant</p>

              <div class="img-container" style="position: relative">
                <img
                  style="position: absolute"
                  id="side"
                  v-if="selectedFileBase64.side"
                  :src="imageUrl.side"
                  class="grey lighten-4 img-to-fit"
                />
                <v-row
                  style="position: absolute"
                  v-if="imageResizeLoader.side"
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-1"
                  ></v-progress-circular>
                </v-row>
              </div>

              <v-btn
                class="mt-2"
                block
                :dark="imageAddAvailable"
                :depressed="!imageAddAvailable"
                :disabled="!imageAddAvailable"
                :color="companySecondaryColor"
                @click="onPickFile('side')"
              >
                Maak foto
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="image/*"
                @change="onFilePicked"
              />
              <v-checkbox
                :color="companyPrimaryColor"
                class="my-2"
                v-if="!busy"
                label="Toestemming voor delen"
                v-model="Socialmedia.side"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm3 x class="upload-image-wrapper">
              <p class="ma-0" style="text-align: center">Achterkant</p>

              <div class="img-container" style="position: relative">
                <img
                  style="position: absolute"
                  id="back"
                  v-if="selectedFileBase64.back"
                  :src="imageUrl.back"
                  class="grey lighten-4 img-to-fit"
                />
                <v-row
                  style="position: absolute"
                  v-if="imageResizeLoader.back"
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-1"
                  ></v-progress-circular>
                </v-row>
              </div>

              <v-btn
                class="mt-2"
                block
                :dark="imageAddAvailable"
                :depressed="!imageAddAvailable"
                :disabled="!imageAddAvailable"
                :color="companySecondaryColor"
                @click="onPickFile('back')"
              >
                Maak foto
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="image/*"
                @change="onFilePicked"
              />

              <v-checkbox
                :color="companyPrimaryColor"
                class="my-2"
                v-if="!busy"
                label="Toestemming voor delen"
                v-model="Socialmedia.back"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm3 class="upload-image-wrapper">
              <p class="ma-0" style="text-align: center">Extra</p>

              <div class="img-container" style="position: relative">
                <img
                  style="position: absolute"
                  id="extra"
                  v-if="selectedFileBase64.extra"
                  :src="imageUrl.extra"
                  class="grey lighten-4 img-to-fit"
                />
                <v-row
                  style="position: absolute"
                  v-if="imageResizeLoader.extra"
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-1"
                  ></v-progress-circular>
                </v-row>
              </div>
              <v-btn
                class="mt-2"
                block
                :dark="imageAddAvailable"
                :depressed="!imageAddAvailable"
                :disabled="!imageAddAvailable"
                :color="companySecondaryColor"
                @click="onPickFile('extra')"
              >
                Maak foto
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="image/*"
                @change="onFilePicked"
              />
              <v-checkbox
                :color="companyPrimaryColor"
                class="my-2"
                v-if="!busy"
                label="Toestemming voor delen"
                v-model="Socialmedia.extra"
              ></v-checkbox>
            </v-flex>

            <v-flex
              xs12
              sm3
              x
              class="upload-image-wrapper"
              v-if="activeCompData.id == 'beautybyroos'"
            >
              <p class="ma-0" style="text-align: center">Extra</p>

              <div class="img-container" style="position: relative">
                <img
                  style="position: absolute"
                  id="back"
                  v-if="selectedFileBase64.extra2"
                  :src="imageUrl.extra2"
                  class="grey lighten-4 img-to-fit"
                />
                <v-row
                  style="position: absolute"
                  v-if="imageResizeLoader.extra2"
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-1"
                  ></v-progress-circular>
                </v-row>
              </div>

              <v-btn
                class="mt-2"
                block
                :dark="imageAddAvailable"
                :depressed="!imageAddAvailable"
                :disabled="!imageAddAvailable"
                :color="companySecondaryColor"
                @click="onPickFile('extra2')"
              >
                Maak foto
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="image/*"
                @change="onFilePicked"
              />

              <v-checkbox
                :color="companyPrimaryColor"
                class="my-2"
                v-if="!busy"
                label="Toestemming voor delen"
                v-model="Socialmedia.extra2"
              ></v-checkbox>
            </v-flex>

            <v-flex
              xs12
              sm3
              class="upload-image-wrapper"
              v-if="activeCompData.id == 'beautybyroos'"
            >
              <p class="ma-0" style="text-align: center">Extra</p>

              <div class="img-container" style="position: relative">
                <img
                  style="position: absolute"
                  id="extra"
                  v-if="selectedFileBase64.extra3"
                  :src="imageUrl.extra3"
                  class="grey lighten-4 img-to-fit"
                />
                <v-row
                  style="position: absolute"
                  v-if="imageResizeLoader.extra3"
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-1"
                  ></v-progress-circular>
                </v-row>
              </div>
              <v-btn
                class="mt-2"
                block
                :dark="imageAddAvailable"
                :depressed="!imageAddAvailable"
                :disabled="!imageAddAvailable"
                :color="companySecondaryColor"
                @click="onPickFile('extra3')"
              >
                Maak foto
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="image/*"
                @change="onFilePicked"
              />
              <v-checkbox
                :color="companyPrimaryColor"
                class="my-2"
                v-if="!busy"
                label="Toestemming voor delen"
                v-model="Socialmedia.extra3"
              ></v-checkbox>
            </v-flex>

            <v-flex class="progress-wrapper" xs12 v-if="imageUploading == true">
              <span>
                <p>{{ Math.round(computedTotalProgress) }}%</p>
                <v-progress-linear
                  active
                  :value="computedTotalProgress"
                  background-color="#f1f1f1"
                  :color="companyPrimaryColor"
                  height="14"
                ></v-progress-linear>
              </span>
            </v-flex>
            <div v-if="!busy">
              <p
                class="upload-image-wrapper"
                style="text-align: left; padding-bottom: 10px; font-size:16px;font-weight: 600;"
              >
                Nieuwe Haarlengte
              </p>
              <v-flex xs12 class="upload-image-wrapper pa-0">
                <v-radio-group
                  style="margin-top:32px"
                  class="pa-0 ma-0"
                  v-model="hairlengthselection"
                  row
                >
                  <v-radio
                    :color="companyPrimaryColor"
                    label="Kort"
                    value="short"
                  ></v-radio>
                  <v-radio
                    :color="companyPrimaryColor"
                    label="Half lang"
                    value="halflength"
                  ></v-radio>
                  <v-radio
                    :color="companyPrimaryColor"
                    label="lang"
                    value="long"
                  ></v-radio>
                  <v-radio
                    :color="companyPrimaryColor"
                    label="lang XXL"
                    value="longxxl"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </div>
            <v-flex xs12 class="upload-image-wrapper ma-0 pt-0">
              <v-menu
                v-if="
                  $store.state.userRole == 'superadmin' ||
                    $store.state.userRole == 'admin' ||
                    $store.state.userRole == 'manager'
                "
                ref="dateDialog"
                :close-on-content-click="false"
                v-model="photoDateDialog"
                transition="scale-transition"
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mt-4"
                    :color="companyPrimaryColor"
                    v-on="on"
                    outlined
                    dense
                    v-model="customPhotoDateFormatted"
                    label="Datum van foto's"
                    append-icon="today"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  :color="companyPrimaryColor"
                  v-model="customPhotoDate"
                  :show-current="true"
                  no-title
                  @input="photoDateDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 class="upload-image-wrapper" v-if="!busy">
              <v-text-field
                class="searchbox"
                outlined
                v-model="search"
                name="searchfield"
                label="Zoeken"
                prepend-inner-icon="search"
                clearable
                single-line
                @click="search = ''"
              ></v-text-field>

              <div class="clientlast">
                <v-list
                  v-for="(searchemployee, index) in filteredEmployees"
                  :key="searchemployee + index"
                  class="pa-0"
                >
                  <v-list-item
                    style="padding: 0px;"
                    :style="{
                      backgroundColor: $vuetify.theme.themes[theme].background,
                    }"
                    :key="searchemployee.name"
                    @click.native="search = searchemployee.name"
                  >
                    <!-- <v-list-tile-avatar color="#f4f7fc">
                          <img v-if="search.photo" :src="search.photo">
                    </v-list-tile-avatar>-->

                    <v-list-item-content>
                      <v-list-item-title class="px-2">
                        {{ searchemployee.name }} {{ searchemployee.lastname }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider
                    v-if="index + 1 < filteredEmployees.length"
                    :key="index"
                  ></v-divider>
                </v-list>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container grid-list-md fluid class="ma-0 pa-2">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex md4 class="text-left">
              <v-btn
                :block="
                  $vuetify.breakpoint.name == 'sm' ||
                    $vuetify.breakpoint.name == 'xs'
                "
                outlined
                depressed
                color="#8B93A6"
                @click="closedialog()"
              >
                Annuleren
              </v-btn>
            </v-flex>
            <v-flex md4 class="text-right">
              <v-radio-group
                class="pt-2 ma-0"
                v-if="!busy"
                v-model="genderselection"
                hide-details
                row
              >
                <v-radio
                  :color="companyPrimaryColor"
                  label="Vrouw"
                  value="female"
                ></v-radio>
                <v-radio
                  :color="companyPrimaryColor"
                  label="Man"
                  value="male"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex md4 class="text-right">
              <v-btn
                :dark="readyForUpload"
                :depressed="!readyForUpload"
                :disabled="!readyForUpload"
                rounded
                :block="
                  $vuetify.breakpoint.name == 'sm' ||
                    $vuetify.breakpoint.name == 'xs'
                "
                :color="companySecondaryColor"
                @click="postClientPhoto()"
              >
                Foto's opslaan
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from "firebase/compat/app";
import axios from "axios";
import uniqid from "uniqid";
import moment from "moment";
import db from "../../firebase/init";
import { bus } from "../../main";
// import imageFileToBase64 from "image-file-to-base64-exif";

import platform from "platform";

export default {
  props: [
    "chosenCustomerInfo",
    "activeComp",
    "activeCompData",
    "selectedBranch",
    "selectedBranchData",
    "namecustomer",
    "chosencustomer",
    "employees",
    "chosenEmployee",
  ],
  data() {
    return {
      createPhotoModal: false,
      checkSocialmedia: false,
      Socialmedia: {
        front: true,
        side: true,
        back: true,
        extra: true,
        extra2: true,
        extra3: true,
      },
      photoDateDialog: false,
      customPhotoDate: null,

      testRet: null,
      testRotation: {
        input: null,
        outpout: null,
      },
      busy: false,
      busy: false,
      leeg: "leeg",
      imageUploading: false,
      HogansDataCustomer: [],
      sorter: null, //Zet foto op de juiste plek
      search: "",

      //Person info
      hairlengthselection: "halflength",
      genderselection: null,
      draaien: "",
      photoBA: 1, // 0 = Before | 1 = After | 3 = Checkup
      before: false,
      after: true,
      checkup: false,

      imageResizeLoader: {
        //loader voor Resize
        front: false,
        side: false,
        back: false,
        extra: false,
        extra2: null,
        extra3: null,
      },

      //Front Image
      imageUrl: {
        front: null,
        side: null,
        back: null,
        extra: null,
        extra2: null,
        extra3: null,
      },
      imageProgress: {
        front: 0,
        side: 0,
        back: 0,
        extra: 0,
        extra2: 0,
        extra3: 0,
        total: 600,
      },

      totalProgress: null,

      selectedFile: {
        front: null,
        side: null,
        back: null,
        extra: null,
        extra2: null,
        extra3: null,
      },

      selectedFileBase64: {
        //Modificatie naar Base64
        front: null,
        side: null,
        back: null,
        extra: null,
        extra2: null,
        extra3: null,
      },

      selectedFileExt: {
        front: null,
        side: null,
        back: null,
        extra: null,
        extra2: null,
        extra3: null,
      },
      image: {
        front: null,
        side: null,
        back: null,
        extra: null,
        extra2: null,
        extra3: null,
      },

      photoCollection: {
        front: null,
        front_thumb: null,
        side: null,
        side_thumb: null,
        back: null,
        back_thumb: null,
        extra: null,
        extra_thumb: null,
        extra2: null,
        extra2_thumb: null,
        extra3: null,
        extra3_thumb: null,
      },
      progress: 0,
    };
  },

  created() {
    bus.$on("getClientPhotoData", (updateModalInfo) => {
      this.getClientPhotos(updateModalInfo);
      this.createPhotoModal = true;
    });
  },

  methods: {
    getClientPhotos(customerID) {
      //Opstart script

      //0 = man | 1 = vrouw
      if (this.chosenCustomerInfo.gender == 0) {
        this.genderselection = "male";
      }
      if (this.chosenCustomerInfo.gender == 1) {
        this.genderselection = "female";
      }
      //Uitzondering op Kind of Anders
      if (
        this.chosenCustomerInfo.gender == 2 ||
        this.chosenCustomerInfo.gender == 3
      ) {
        this.genderselection = null;
      }
    },

    onPickFile(photo) {
      this.sorter = photo;
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      this.imageResizeLoader[this.sorter] = true;
      const maxWidth = 1400;
      const maxHeight = 1400;
      const quality = 0.9;
      var re = /(?:\.([^.]+))?$/; //Pak laatste extensie
      const files = event.target.files;
      this.selectedFile[this.sorter] = event.target.files[0];
      // console.log(this.selectedFile[this.sorter]);
      var fileRotate = this.selectedFile[this.sorter];
      this.selectedFileExt[this.sorter] = re.exec(
        event.target.files[0].name,
      )[0]; // ".jpg"
      let vm = this;

      console.log(this.selectedFile[this.sorter]);
      const fileReader = new FileReader();
      let readyforResize = null;

      vm.selectedFileBase64[vm.sorter] = event.target.files[0];
      vm.imageResizeLoader[vm.sorter] = false;

      fileReader.onloadend = function() {
        //Luistert of het bestand geupload is.

        vm.imageUrl[vm.sorter] = fileReader.result;
        readyforResize = fileReader.result;
      };

      fileReader.readAsDataURL(files[0]); //Bestand omzetten naar BASE64 en dan de eerste file pakken.

      this.image[this.sorter] = files[0];
    },

    checkActiveComp() {
      if (this.activeCompData.id == "beautybyroos") {
        return "three-buttons";
      } else {
        return "two-buttons";
      }
    },

    postClientPhoto() {
      if (this.search == "") {
        this.$swal({
          title: `Wie heeft de foto gemaakt?`,
          animation: true,
          // imageUrl: 'https://unsplash.it/400/200',
          text: `Vul een naam in wie de foto heeft gemaakt.`,
          showConfirmButton: true,
          confirmButtonColor: "#00adef",
          confirmButtonText: "Ja",
        });
      } else {
        this.imageUploading = true;
        this.busy = true;
        this.imageProgress.total = 0;
        //Dit in een LOOP van 6 gooien.
        //Afbeelding uploader
        this.photoCollection.front = null;
        this.photoCollection.front_thumb = null;
        this.photoCollection.side = null;
        this.photoCollection.side_thumb = null;
        this.photoCollection.back = null;
        this.photoCollection.back_thumb = null;
        this.photoCollection.extra = null;
        this.photoCollection.extra_thumb = null;
        this.photoCollection.extra2 = null;
        this.photoCollection.extra2_thumb = null;
        this.photoCollection.extra3 = null;
        this.photoCollection.extra3_thumb = null;

        if (this.selectedFile !== null) {
          this.saveDisabled = true;
          let endObject = Object.entries(this.selectedFile).length;
          let progressbarTotal = null; //Telt alle niet afbeeldingen percentage op
          var uploadChecker = null; // Telt alles bij elkaar dan volgende stap
          Object.entries(this.selectedFile).map(([key, value]) => {
            var UniqueFilename = null;
            var UniqueFullpath = null;
            var UniqueFullpathThumb = null;

            // Check voor lege fotos.
            if (this.selectedFileExt[key] !== null) {
              this.imageProgress.total = this.imageProgress.total + 100;
              console.log(
                this.activeComp +
                  "_clientid_" +
                  this.chosenCustomerInfo.id +
                  "_" +
                  uniqid() +
                  "_" +
                  key +
                  this.selectedFileExt[key],
              );
              UniqueFilename =
                this.activeComp +
                "_clientid_" +
                this.chosenCustomerInfo.id +
                "_" +
                uniqid() +
                "_" +
                key +
                this.selectedFileExt[key];

              let companyID = this.activeComp;
              const fd = new FormData(); //Default Javascript object Data naar form-data
              fd.append("image", this.selectedFile[key], UniqueFilename);
              let ref = firebase
                .storage()
                .ref(this.activeComp + "/" + UniqueFilename);
              // console.log("Fullpath", "/" + UniqueFilename);

              let uploadTask = ref.put(this.selectedFileBase64[key]);

              uploadTask.on(
                "state_changed",
                (taskSnapshot) => {
                  this.imageProgress[key] = Math.round(
                    (taskSnapshot.bytesTransferred / taskSnapshot.totalBytes) *
                      100,
                  );
                },
                (error) => {
                  console.error("Error uploading photo", error);
                },
                () => {
                  uploadChecker++;
                  console.log(uploadChecker);
                  if (uploadChecker == endObject) {
                    this.uploadCollectionPhotos(); // Voer de update uit.
                  }
                  console.log(
                    "The photo upload is compleet",
                    this.selectedFile[key],
                  );
                },
              );

              UniqueFullpath =
                "https://firebasestorage.googleapis.com/v0/b/clientphotos/o/" +
                companyID +
                "%2F" +
                UniqueFilename +
                "?alt=media&token=";
              UniqueFullpathThumb =
                "https://firebasestorage.googleapis.com/v0/b/clientphotos/o/" +
                companyID +
                "%2F" +
                "thumb_" +
                UniqueFilename +
                "?alt=media&token=";
              this.photoCollection[key] = UniqueFullpath;
              this.photoCollection[key + "_thumb"] = UniqueFullpathThumb;
            } else {
              uploadChecker++;
            }
          });
        } else {
          console.log("No image applied");
        }
      }
    },

    uploadCollectionPhotos() {
      db.collection("clientphotos")
        .doc()
        .set({
          //Client data
          customerName: this.namecustomer,
          salonhub_ID: Number(this.chosenCustomerInfo.id),
          gender: this.genderselection,
          hairlength: this.hairlengthselection,

          //Photo data
          photoCollection: this.photoCollection,
          datePhoto: this.customPhotoDate
            ? `${this.customPhotoDate}T10:00`
            : moment().format("YYYY-MM-DDTHH:mm"),
          socialmedia: this.Socialmedia,
          photoBA: this.photoBA,
          socialposted: false,

          //Company and Branch Data
          company: this.activeComp,
          companyName: this.selectedBranchData.compId,
          birthday: this.chosencustomer.birthday,
          branchName: this.selectedBranchData.branchName,
          branch: this.selectedBranch,
          employee: this.search,
        })
        .then(() => {
          console.info("Photo collectie firecloud created! ");
          this.busy = false;
          this.imageUploading = false;
          // Wachten tot Thumb gegenereerd is.
          // this.$emit("updateClient");

          // db.collection("log")
          //   .add({
          //     time: new Date(),
          //     logType: "info",
          //     user: this.userFirstName + " " + this.userLastName,
          //     userType: this.userRole,
          //     company: this.userCompany,
          //     actionType: "User Action",
          //     software: String(platform.os),
          //     browser: platform.name + ' ' + platform.version,
          //     pillarrrVersion: this.$store.state.version,
          //     action:
          //       "Foto's geupload : " +
          //       this.activeCompData.name +
          //       " " +
          //       this.selectedBranchData.branchName,
          //     extra: null
          //   })
          //   .catch(error => {
          //     console.error("Error logging Photo upload: ", error);
          //   });

          this.closedialog();

          this.$emit("updateClient");
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
          db.collection("log")
            .add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              action:
                "Fout bij uploaden foto's: " +
                this.activeCompData.name +
                " " +
                this.selectedBranchData.branchName,
              extra: JSON.stringify(error),
            })
            .catch((error) => {
              console.error("Error logging Photo upload: ", error);
            });
        });
    },

    closedialog() {
      this.createPhotoModal = false;
      this.customPhotoDate = null;
      Object.assign(this.$data, this.$options.data());
    },
    formatDate(date) {
      // Datum omvormen naar Europese leesbare datum
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
  },
  computed: {
    customPhotoDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.customPhotoDate
        ? this.formatDate(this.customPhotoDate)
        : null;
    },
    showFullScreen() {
      let browserWidth = window.innerWidth;
      if (browserWidth < 450) {
        return true;
      } else {
        return false;
      }
    },
    computedTotalProgress() {
      return (this.progress =
        ((this.imageProgress.front +
          this.imageProgress.side +
          this.imageProgress.back +
          this.imageProgress.extra) *
          100) /
        this.imageProgress.total);
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },

    cssPropPrimaryColor() {
      return {
        "--primary-Color": "#5F1D9C",
      };
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    readyForUpload() {
      if (
        this.genderselection &&
        !this.imageResizeLoader.front &&
        !this.imageResizeLoader.side &&
        !this.imageResizeLoader.back &&
        !this.imageResizeLoader.extra &&
        !this.imageUploading
      ) {
        if (
          this.userRole == "superadmin" ||
          this.userRole == "admin" ||
          this.userRole == "manageradmin"
        ) {
          let numbers = 0;
          if (
            this.selectedFile.front ||
            this.selectedFile.side ||
            this.selectedFile.back ||
            this.selectedFile.extra ||
            this.selectedFile.extra2 ||
            this.selectedFile.extra3
          ) {
            return true;
          }
        } else {
          if (
            this.selectedFile.front &&
            this.selectedFile.side &&
            this.selectedFile.back
          ) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },

    imageAddAvailable() {
      if (
        this.imageResizeLoader.front ||
        this.imageResizeLoader.side ||
        this.imageResizeLoader.back ||
        this.imageResizeLoader.extra ||
        this.busy
      ) {
        return false;
      } else {
        return true;
      }
    },

    filteredEmployees() {
      if (Object.keys(this.employees).length !== 0) {
        return this.employees.filter((client) => {
          let clientname = client.name;

          return (
            clientname.toLowerCase().includes(this.search.toLowerCase()) &&
            client.status == 0
          );
        });
      }
    },
  },
};
</script>

<style scoped>
/* @media screen and (orientation: landscape) {
  .upload-image-wrapper {
    display: none;
  }
}

@media screen and (orientation: portrait) {
  .turnportrait {
    display: none;
  }
  #content-wrapper {
    -webkit-transform: rotate(0deg);
  }
} */

.choose-measurement-type-wrapper {
  padding: 5px 15px 20px 15px;
}

.choose-measurement-type-buttons {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.measurement-type-button {
  width: calc(50% - 1px);
  float: left;
  height: 32px;
  text-align: center;
  color: black;
  font-size: 14px;
  font-weight: 600;
  line-height: 28px;
  background-color: #fff;
  border-bottom: 1px solid black;
  border-top: 1px solid black;
  cursor: pointer;
}

.measurement-type-button.three-buttons {
  width: calc(33% - 1px);
  float: left;
  height: 32px;
  text-align: center;
  color: black;
  font-size: 14px;
  font-weight: 600;
  line-height: 28px;
  background-color: #fff;
  border-bottom: 1px solid black;
  border-top: 1px solid black;
  cursor: pointer;
}

.measurement-type-button:hover {
  cursor: pointer;
}

.measurement-type-button.active {
  background-color: black;
  color: #fff;
}

.measurement-type-button.one {
  border-left: 1px solid black;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.measurement-type-button.two {
  border-right: 1px solid black;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.measurement-type-button.two.three-buttons {
  border-right: 1px solid black;
  border-left: 1px solid black;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.measurement-type-button.three {
  border-right: 1px solid black;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.img-container {
  width: 160px;
  height: 160px;
  justify-content: center;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  margin: 0 auto;
  background-color: #f5f5f5;
  border: 1px solid #eee;
}

.img-container .img-to-fit {
  flex: 1;
  height: 100%;
}

.img-loader {
  position: relative;
  top: 4px;
  background: url("../../assets/spinner.svg") no-repeat center;
  background-size: 40px;
  margin: auto;
  width: 40px;
  height: 40px;
  animation: 1s spinrotator linear infinite;
  z-index: 2;
}

@keyframes spinrotator {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.clientlast .v-list.theme--light {
  padding: 0px;
}

.clientlast {
  max-height: 200px;
  overflow-y: scroll;
  border: 1px solid #eee;
}

.searchbox {
  height: 60px;
}

.img-loader-space {
  position: relative;
  top: 0px;
  background: url("../../assets/loading.gif") no-repeat center;
  width: 160px;
  height: 160px;
}

.img-loader-span {
  position: relative;
  top: 46px;
  width: 100px;
  font-size: 13px;
}

.progress-wrapper {
  height: 35px;
}
.progress-wrapper .v-progress-linear {
  margin: 0;
}
.upload-image-wrapper {
  padding: 4px;
}

.upload-image-wrapper p {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}
.image-placeholder {
  position: relative;
  width: 160px;
  height: 160px;
  background-color: #f1f1f1;
  z-index: 1;
}

.image-placeholder-loading {
  position: relative;
  width: 160px;
  height: 160px;
  background-color: #f1f1f1;
  z-index: 10;
}
</style>
